import { useState } from 'react';
import { Form, Input, Row, Select } from 'antd';
import FilterButton from '../../Atoms/FilterButton/FilterButton';
import './Filters.less';
import { useAppDispatch, useAppSelector } from '../../../store/hooks/hooks';
import { selectUsersAssignedTo, setTaskFilters, setCancelToken, selectCancelToken } from '../../../store/slice/taskSlice';
import { ReactComponent as SearchOutlined } from '../../../res/svg/search.svg';
import SelectUsers from '../../Molecules/SelectUsers/SelectUsers';
import User from '../../../models/User';
import { rolPermission } from '../../../utils/functions'
import axios from 'axios';


/**
 * @component ReportsFilters.tsx
 * @description ReportsFilters.
 * @return { Component }
 */
interface optionsState {
  tipo: string;
  value: number;
  nombre: string;
  valueId: number;
}

function Filters() {
  const { Option } = Select;
  const dispatch = useAppDispatch();
  const usersAssignedTo = useAppSelector(selectUsersAssignedTo);
  const [usersSelected, setUsersSelected] = useState<string[]>([]);
  //@ts-ignore
  const currentUser: User = JSON.parse(localStorage.getItem('currentUser'))
  const filtros = useAppSelector(state => state.task.filtros);
  const cancelToken = useAppSelector(selectCancelToken)

  const permissionFilters = () =>{
    let viewFilters = false;
    if(currentUser.rol !== null){
      if(currentUser.rol.permiso === rolPermission.COORDINACION || currentUser.rol.permiso === rolPermission.SUPERVISION || currentUser.rol.permiso === rolPermission.AUTOGESTION){
        viewFilters = true;
      }
    }
    return viewFilters;
  }

  const onChangeState = (selectValue: Array<string>, option: Array<[]>) => {
    /**
    * Se maneja el segundo parametro de la funcion que es option ya que es de ahi
    * que sacamos de title el valor verdadero del estado selecionado
    */
    const stateTask = option.filter((value: any) => value.className.tipo === 'tarea').map((value: any) => value.className.valueId);
    const stateTaskUser = option.filter((value: any) => value.className.tipo === 'tareaUsuario').map((value: any) => value.className.valueId);
    dispatch(setTaskFilters({estado: stateTask, tareaUsuarioEstado: stateTaskUser}))
  };

  const userSelectOnChange = (selectValue: Array<string>) => {
    setUsersSelected([...selectValue]);
    dispatch(setTaskFilters({usuariosAsignados: [...selectValue]}))
  };

  /**
   * Se debe crear un arreglo de estados con values distintos, ya que
   * si alguno de ellos tenia un value repetido se seleccionaba 2 veces en el
   * componente, por eso se trabajo con otro parametro que es el valueId el cual
   * ese es el id en la base de datos
   */
   const estadosTareaEstadosUsuarios = [
    { tipo: 'tarea', value: 1, nombre: 'Creada', valueId: 1 },
    { tipo: 'tarea', value: 2, nombre: 'Asignada', valueId: 2 },
    { tipo: 'tarea', value: 3, nombre: 'Pendiente', valueId: 4 },
    { tipo: 'tarea', value: 4, nombre: 'Rechazada', valueId: 5 },
    { tipo: 'tarea', value: 5, nombre: 'Cerrada', valueId: 3 },
    { tipo: 'tareaUsuario', value: 6, nombre: 'Finalizada Completa', valueId: 4 },
    { tipo: 'tareaUsuario', value: 7, nombre: 'Finalizada Incompleta', valueId: 5 },
  ]

  return (
    <Row gutter={24} className="ml-filter__layout">
      <div style={{marginRight: '10px'}}>
        <Input
          className="ml-filters-search-input"
          placeholder="Buscar tareas"
          prefix={<SearchOutlined/>}
          allowClear
          value={filtros.search}
          size="large"
          onChange={(e) => {
            const search = e.target.value;
            
            if (typeof cancelToken != typeof undefined) {
              cancelToken.cancel("Operation canceled due to new request.")
            }
            dispatch(setCancelToken(axios.CancelToken.source()));

            dispatch(setTaskFilters({search}))
          }}
        />
      </div>
      <div className={'container-filters'} style={{display: permissionFilters() ? 'block' : 'contents'}}>
        <Form name="customized_form_controls" layout="inline">
            <div className={'filter-estado'}>
              <Form.Item name={'nombre'} label="Estado">
                <Select
                  placeholder="Estado"
                  className={'select-state'}
                  mode="multiple"
                  allowClear
                  size={'large'}
                  onChange={onChangeState}
                  maxTagCount={'responsive'}
                  filterOption={(inputValue, option: any) =>
                    (option.children)
                      .toString()
                      .toLowerCase()
                      .indexOf(inputValue.toLowerCase()) !== -1
                  }
                >
                  {/*Se maneja la varibale className, y se incluye el objeto ya que es apartir de ahi
                    que jugamos con los valores y lo mandamos como query params
                  */}
                  {
                    estadosTareaEstadosUsuarios.map((state: optionsState)=>(
                      <Option key={state.value} value={state.value} className={state}>
                        {state.nombre}
                      </Option>
                    ))
                  }
                </Select>
              </Form.Item>
            </div>
            {
              permissionFilters() ?
              <div className={'filter-asignados'}>
              <Form.Item name={'asignadas'} label="Asignadas a">
                <SelectUsers value={usersSelected} onChange={userSelectOnChange} placeholder={'Todos'} users={usersAssignedTo} avatarCount={4} className={'select-users-assigned'}/>
              </Form.Item>
              </div> : null
            }
        </Form>
      </div>
      <div>
        <FilterButton />
      </div>
    </Row>
  );
}

export default Filters;
